import { render, staticRenderFns } from "./ScreenHead.vue?vue&type=template&id=7a210d30&scoped=true&"
import script from "./ScreenHead.vue?vue&type=script&lang=js&"
export * from "./ScreenHead.vue?vue&type=script&lang=js&"
import style0 from "./ScreenHead.vue?vue&type=style&index=0&id=7a210d30&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a210d30",
  null
  
)

export default component.exports